import { render, staticRenderFns } from "./QuickWarn.vue?vue&type=template&id=c47af052&scoped=true&"
import script from "./QuickWarn.vue?vue&type=script&lang=js&"
export * from "./QuickWarn.vue?vue&type=script&lang=js&"
import style0 from "./QuickWarn.vue?vue&type=style&index=0&id=c47af052&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47af052",
  null
  
)

export default component.exports